var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2,43.89L50.43,11.22c-.18-.67-.77-1.13-1.46-1.13H15.04c-.69,0-1.29,.46-1.46,1.13L4.8,43.89c-.2,.74,.19,1.51,.9,1.8l20.45,8.1c.84,.33,1.78-.14,2.02-1.02l3.83-14.27,3.83,14.27c.24,.87,1.18,1.35,2.02,1.02l20.44-8.1c.72-.29,1.12-1.06,.91-1.8h0Zm-8.77-20.97c-5.7-.7-10.57-4.46-12.69-9.8h10.05l2.64,9.8ZM16.19,13.13h9.9c-2.1,5.29-6.9,9.03-12.53,9.79l2.63-9.79Zm22.13,37.22l-4.86-18.08c-.4-1.49-2.52-1.49-2.93,0l-4.84,18.08-17.62-6.97,4.66-17.34c7.65-.5,14.22-5.62,16.59-12.91h5.21c2.39,7.34,9.03,12.47,16.74,12.92l4.66,17.33-17.61,6.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBottom);
export default __webpack_public_path__ + "static/media/icon_bottom.a842e151.svg";
export { ForwardRef as ReactComponent };